export default {
      id: "burger_menu-usage",
      viewBox: "0 0 35.1 28",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#burger_menu-usage",
      toString: function () {
        return this.url;
      }
    }